import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMcafeeComponent } from './simple-icons-mcafee.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMcafeeComponent ],
    exports:      [ SimpleIconsMcafeeComponent ],
    bootstrap:    []
})
export class SimpleIconsMcafeeModule {}
